import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
